import { render } from "./Environment.vue?vue&type=template&id=b7a84c4a&scoped=true"
import script from "./Environment.vue?vue&type=script&lang=js"
export * from "./Environment.vue?vue&type=script&lang=js"

import "./Environment.vue?vue&type=style&index=0&id=b7a84c4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a84c4a"]])

export default __exports__